import React from 'react';

const styles = {
  input: {
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    width: '100%'
  }
};

const Input = ({ style, ...rest }) => (
  <input style={{ ...styles.input, ...style }} {...rest} />
);

export default Input;
